<div class="tw-flex tw-flex-col tw-h-full tw-justify-center">
  <div class="tw-text-center">
    <bit-icon [icon]="noCredentialsIcon" aria-hidden="true"></bit-icon>
    <h2 bitTypography="h4" class="tw-mt-3">{{ "noPasswordsToShow" | i18n }}</h2>
    <div>{{ "noRecentlyGeneratedPassword" | i18n }}</div>
  </div>
</div>
